import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import fastClick from 'fastclick'
import VueWechatTitle from 'vue-wechat-title'
import 'babel-polyfill'
import Navigation from 'vue-navigation'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Meta from 'vue-meta'
import VueOccupy from 'vue-occupy'
import {
  Button,
  Swipe,
  SwipeItem,
  Popup,
  Picker,
  Actionsheet,
  Checklist,
  Toast,
  Indicator,
  MessageBox
} from 'mint-ui';
import 'mint-ui/lib/style.css'
import {
  DateTime
} from 'vue-ydui/dist/lib.rem/datetime';
import {
  Switch
} from 'vue-ydui/dist/lib.rem/switch';
import {Radio, RadioGroup} from 'vue-ydui/dist/lib.rem/radio';
import VeRing from 'v-charts/lib/ring.common' // 环形图
import VeHistogram from 'v-charts/lib/histogram.common' // 柱形图
import {Icon} from 'ant-design-vue'
import md5 from 'js-md5'
import * as filters from './filters'

Vue.config.productionTip = false
// 处理fastclick导致的输入框点击无响应的问题
fastClick.prototype.focus = function(targetElement) {
  var length;
  if (
    /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
    targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' && targetElement.type !== 'month' &&
    targetElement.type !== 'email'
  ) {
    length = targetElement.value.length;
    targetElement.setSelectionRange(length, length);
    /* 修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘 */
    targetElement.focus();
  } else {
    targetElement.focus();
  }
};

import './assets/css/reset.css'
import './assets/css/border.css'
import 'swiper/dist/css/swiper.css'

Vue.use(VueWechatTitle)
Vue.use(Icon)
Vue.use(Meta)
Vue.use(VueOccupy)
Vue.use(Navigation, {
  router,
  store
})
Vue.use(VueAwesomeSwiper)
Vue.component(Toast)
Vue.component(Indicator)
Vue.component(MessageBox)
Vue.component(VeRing.name, VeRing)
Vue.component(VeHistogram.name, VeHistogram)
Vue.component(Button.name, Button)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)
Vue.component(Actionsheet.name, Actionsheet)
Vue.component(Checklist.name, Checklist)
Vue.component(DateTime.name, DateTime)
Vue.component(Switch.name, Switch)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 引入了Toast 就需要把该变量暴露到全局对象里面
window.Toast = Toast
window.Indicator = Indicator
window.MessageBox = MessageBox
fastClick.attach(document.body)

Vue.prototype.$md5 = md5;


// 自定义长按指令
Vue.directive('longpress', {
  bind: function(el, binding, vNode) {
    // 确保提供的表达式是函数
    if (typeof binding.value !== 'function') {
      // 获取组件名称
      const compName = vNode.context.name;
      // 将警告传递给控制台
      let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be `;
      if (compName) {
        warn += `Found in component '${compName}' `
      }
      console.warn(warn);
    }
    // 定义变量
    let pressTimer = null;
    // 定义函数处理程序
    // 创建计时器（ 1秒后执行函数 ）
    let start = (e) => {
      if (e.type === 'click' && e.button !== 0) {
        return;
      }
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // 执行函数
          handler();
        }, 1000)
      }
    }
    // 取消计时器
    let cancel = (e) => {
      // 检查计时器是否有值
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    }
    // 运行函数
    const handler = (e) => {
      // 执行传递给指令的方法
      binding.value(e)
    }
    // 添加事件监听器
    el.addEventListener("mousedown", start);
    el.addEventListener("touchstart", start);
    // 取消计时器
    el.addEventListener("click", cancel);
    el.addEventListener("mouseout", cancel);
    el.addEventListener("touchend", cancel);
    el.addEventListener("touchcancel", cancel);
  }
})


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount("#app")
